export const CONNECTIONS_GET = 'CONNECTIONS_GET';
export const LEAD_SCORE_SETTINGS_GET = 'LEAD_SCORE_SETTINGS_GET';
export const WEB_TRACKING_COUNTERS_GET = 'WEB_TRACKING_COUNTERS_GET';
export const ANALYTICS_TRACK_CTA = 'ANALYTICS_TRACK_CTA';
